import {ProcedureFlowchart} from 'procedures/ProcedureDomainTypes';

export enum ProceduresActionType {
  UPDATED_FLOWCHART = 'UPDATED_FLOWCHART',
  RELEASED_FLOWCHART = 'RELEASED_FLOWCHART',
}

export interface ProceduresActionUpdatedFlowchart {
  type: ProceduresActionType.UPDATED_FLOWCHART;
  procedureId: string;
  flowchart: ProcedureFlowchart;
}
export interface ProceduresActionReleasedFlowchart {
  type: ProceduresActionType.RELEASED_FLOWCHART;
  procedureId: string;
}

export type ProceduresAction = ProceduresActionUpdatedFlowchart | ProceduresActionReleasedFlowchart;

export function procedureFlowchartUpdated(
  procedureId: string,
  flowchart: ProcedureFlowchart
): ProceduresActionUpdatedFlowchart {
  return {
    type: ProceduresActionType.UPDATED_FLOWCHART,
    procedureId,
    flowchart,
  };
}

export function procedureFlowchartReleased(procedureId: string): ProceduresActionReleasedFlowchart {
  return {
    type: ProceduresActionType.RELEASED_FLOWCHART,
    procedureId,
  };
}
